// Generate a random string made with numbers!
export const randomString = (length = 5) => { return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, length); };

// Refer to Lodash for other string functions
// https://lodash.com/docs/4.17.11

// import { camelCase, capitalize, kebabCase, snakeCase } from 'lodash'
